import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'ConnectorLogPage.ConnectorLogs',
    defaultMessage: 'Connector Logs'
  },
  loading: {
    id: 'ConnectorLogPage.loading',
    defaultMessage: 'Loading...'
  },
  back: {
    id: 'ConnectorLogPage.Back',
    defaultMessage: 'Back to Installed Apps'
  },
  errorTitle: {
    id: 'UnrecoverableError.Title',
    defaultMessage: 'Something went wrong...'
  },
  errorMessage: {
    id: 'UnrecoverableError.Message',
    defaultMessage: "It's not you, it's us. There was a problem with the system which caused your request to fail."
  }
})
